import * as React from 'react'
import { sbEditable, SbEditableBlok } from '@storyblok/storyblok-editable'
import styled from 'styled-components'
import { typoHeading6 } from '../../lib/styles/Typography'
import { SbAsset } from '../../types'

const StyledWrapper = styled.div<{ $marginBlock: string }>`
  width: 100%;
  margin-block: ${({ $marginBlock }) => $marginBlock || '4rem'};
`

const StyledLogoGrid = styled.div<{ $length: number, $rowCount: number }>`
 display: grid;
 grid-template-columns: repeat(${({ $rowCount }) => $rowCount}, 1fr);
 gap: 1rem;

 @media screen and (max-width: 768px) {
  grid-template-columns: repeat(2, 1fr);
 }
`

const StyledTitle = styled.h6`
  ${typoHeading6}
  margin-bottom: 1.5rem;
  text-align: center;
`

const StyledImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
  flex-shrink: 0;

  @media screen and (min-width: 768px) {
    padding: 0 1.5rem;
  }
`

const StyledImage = styled.img<{ $imageSize: string }>`
  height: ${({ $imageSize }) => $imageSize || '2.5rem'};
  object-fit: contain;
  width: ${({ $imageSize }) => $imageSize || '6rem'};
`

const StyledDescription = styled.p`
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.black[1]};
  font-size: 1.125rem;
  font-weight: 600;
  text-align: center;
`

export interface LogoCarouselProps {
  blok: SbEditableBlok & {
    title: string
    imageSize: string
    logoCarouselItems: SbAsset[]
    marginBlock: string
    rowCount: number
  }
}

export const LogoCarousel = ({ blok }: LogoCarouselProps) => {
  const title = blok.title
  const imageSize = blok.imageSize
  const marginBlock = blok.marginBlock
  const logoCarouselItems = blok.logoCarouselItems
  const rowCount = blok.rowCount || logoCarouselItems.length

  return (
    <StyledWrapper {...sbEditable(blok)} $marginBlock={marginBlock}>
      {!!title && <StyledTitle>{title}</StyledTitle>}
      <StyledLogoGrid $length={logoCarouselItems.length} $rowCount={rowCount}>
        {logoCarouselItems.map((logoCarouselItem) => {
          return (
            <StyledImageWrapper key={logoCarouselItem.id}>
              <StyledImage src={logoCarouselItem.filename} alt={logoCarouselItem.alt} $imageSize={imageSize} />
              <StyledDescription>{logoCarouselItem.name}</StyledDescription>
            </StyledImageWrapper>
          )
        })}
      </StyledLogoGrid>
    </StyledWrapper>
  )
}
